import type * as React from 'react';
import sessionExpired, {
	type SessionExpiredAction,
} from '@Application/Security/Authentications/Actions/sessionExpired';
import userRevoked, {
	type UserRevokedAction,
} from '@Application/Security/Authentications/Actions/userRevoked';

/**
 * Revoking first purges every store that handles `USER_REVOKED`; the expiry then settles the session
 * as `'anonymous'` (the revocation alone would reset it to `'unknown'` and trigger a new probe).
 */
export default () => {
	return async (
		dispatch: React.Dispatch<UserRevokedAction | SessionExpiredAction>,
	): Promise<SessionExpiredAction> => {
		dispatch(userRevoked());

		const action = sessionExpired();
		dispatch(action);
		return action;
	};
};
